export const FPTI = {
  EVENTS: {
    APPLICATION_START: "application_start",
    APPLICATION_COMPLETE: "application_complete",
  },
  IDENTIFIERS: {
    APPLICATION_SUBMISSION: "application_submission",
  },
  LINKS: {
    SUBMIT_APPLICATION: "submit_application",
    VERIFY_CAPTCHA: "verify_captcha",
  },
};
